import { j as t } from "../../jsx-runtime-ClSzPYp4.js";
import o from "react";
import { COOKIE_MANAGEMENT_EVENT_ACTION as s } from "../cookieManagementTypes.mjs";
class m extends o.Component {
  constructor(r) {
    super(r), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(r, e) {
    this.props.onCookieManagementEvent(s.ERROR, {
      error: r,
      errorInfo: e
    });
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ t.jsx(t.Fragment, {}) : this.props.children;
  }
}
export {
  m as default
};
